var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56858 1.89323C8.7287 1.50825 9.27407 1.50825 9.43419 1.89323L11.2058 6.15277C11.2733 6.31507 11.426 6.42596 11.6012 6.44001L16.1997 6.80867C16.6153 6.84199 16.7839 7.36067 16.4672 7.63192L12.9636 10.6331C12.8301 10.7475 12.7718 10.9269 12.8126 11.0979L13.883 15.5853C13.9798 15.9909 13.5385 16.3114 13.1827 16.0941L9.24572 13.6894C9.09572 13.5978 8.90706 13.5978 8.75705 13.6894L4.82006 16.0941C4.46423 16.3114 4.02302 15.9909 4.11976 15.5853L5.19017 11.0979C5.23095 10.9269 5.17266 10.7475 5.03916 10.6331L1.53556 7.63192C1.2189 7.36067 1.38743 6.84199 1.80305 6.80867L6.40159 6.44001C6.5768 6.42596 6.72943 6.31507 6.79693 6.15278L8.56858 1.89323Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.39068aa96552accc45c09029551f9071.svg";
export { ForwardRef as ReactComponent };